/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { PaisesOro, TiposVia } from '../../../types/PersonalData';
import { TarjetaOroHelper } from '../TarjetaOroHelper';
import { useAuthStore } from '../../../store/AuthContext';
import IconChat from '../../../Icons/IconChat';
import { WaEventsConstants } from '../wa-buttons/WaEventsConstants';
import { WaEventConponentFactory } from '../wa-buttons/WaEventConponentFactory';

interface Props {
  submitForm: () => void;
  handleChange: (key: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  tiposVia: TiposVia[];
  load: boolean;
  paises: PaisesOro[];
  isDatosIncompletos: boolean;
  cuota: number;
}

const FacturacionOroForm: FC<Props> = (props) => {
  const {
    handleChange,
    handleChangeSelect,
    tiposVia,
    submitForm,
    load,
    paises,
    isDatosIncompletos,
    cuota,
  } = props;
  const dataUser = useAuthStore();
  const fromApp = dataUser.user.isApp === 'false' ? 'web' : 'app_club';

  const { t } = useTranslation();
  const waEventConponentFactory = new WaEventConponentFactory(t);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });
  const validarTipoVia = (value: any) => {
    return value !== '0';
  };

  const [visible, setVisible] = useState<boolean>(false);

  const onCheck = () => {
    TarjetaOroHelper.hideErrorWhenChecked();
  };

  TarjetaOroHelper.bindResetToBack(reset);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('fact-oro-btn').click();
    }
  };
  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        'section.o-section--large.form-oro.bloque-form.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    } else {
      const element = document.querySelector(
        'section.o-section--large.form-oro.bloque-form',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const isVisible = document
      .querySelector('section.o-section--large.form-oro.bloque-form')
      .classList.contains('visible');
    if (isVisible) setVisible(true);
  }, []);

  return (
    <>
      <form
        id="form-oro"
        className={`form-edit-facturacion}`}
        noValidate
        onSubmit={handleSubmit(() => {
          submitForm();
        })}
      >
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group u-margin-bottom-large">
              <label htmlFor="titular" className="control-label">
                {t('tarjetas.hazte-oro.bank-account')}
              </label>
              <div className="form-control-block u-margin-bottom">
                <input
                  type="text"
                  className={`form-control ${errors.cuenta ? 'error' : ''}`}
                  id="cuenta"
                  data-rule-required="true"
                  // placeholder="ES98 2038 5778 88 0123456789"
                  maxLength={24}
                  {...register('cuenta', {
                    required: true,
                    pattern: /^[ES]{2}[0-9]{22}$/,
                  })}
                  onChange={(e) => handleChange('cuenta', e)}
                />
                {errors.cuenta && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="numcuenta-error"
                    className="error"
                    htmlFor="cuenta"
                  >
                    {t('validaciones.not-valid-account')}
                  </label>
                )}
              </div>
            </div>
          </div>
        </div>
        {(() => {
          if (load) {
            return (
              <>
                <div className="row u-margin-bottom-large">
                  <div className="col-12 col-md-8">
                    <legend>{t('tarjetas.hazte-oro.fact-direction')}</legend>
                  </div>
                </div>
                <div className="row u-margin-bottom">
                  <div className="col-12 col-md-3">
                    <div className="form-group u-margin-bottom-large">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="codFactu" className="control-label">
                        {t('datos.directions.postalCode')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.codFactu ? 'error' : ''
                          }`}
                          id="codFactu"
                          maxLength={5}
                          {...register('codFactu', {
                            required: true,
                            pattern: /^[0-9]+$/i,
                          })}
                          onChange={(e) => {
                            // corregirCPifGibraltar(e, 'cod-factu');
                            handleChange('postalCode', e);
                            // manageProvinceByCP(e, 'provincia-factu');
                          }}
                        />
                        {errors.codFactu &&
                          errors.codFactu.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="codFactu-error"
                              className="error"
                              htmlFor="codFactu"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                        {errors.codFactu && errors.codFactu.type === 'pattern' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="codFactu-error"
                            className="error"
                            htmlFor="codFactu"
                          >
                            {t('validaciones.not-valid-postalCode-spain')}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="form-group select-wrapper u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label className="control-label" htmlFor="locaFactu">
                        {t('datos.directions.locality')}
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.locaFactu ? 'error' : ''
                        }`}
                        id="locaFactu"
                        {...register('locaFactu', {
                          required: true,
                        })}
                        onChange={(e) => handleChange('localidad', e)}
                      />
                      {errors.locaFactu &&
                        errors.locaFactu.type === 'required' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="locaFactu-error"
                            className="error"
                            htmlFor="locaFactu"
                          >
                            {t('validaciones.empty-value')}
                          </label>
                        )}
                    </div>
                  </div>
                  <div className="col-12 col-md-2">
                    <div className="form-group select-wrapper u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label className="control-label" htmlFor="tipo-via-factu">
                        {t('datos.directions.roadType')}
                      </label>
                      <div className="form-control-block">
                        <select
                          className={`form-control valid ${
                            errors.tipoVia ? 'error' : ''
                          }`}
                          id="tipoVia"
                          {...register('tipoVia', {
                            validate: (value) => validarTipoVia(value),
                          })}
                          onChange={(e) => handleChangeSelect('tipoVia', e)}
                        >
                          <option value={0}>
                            {t('datos.directions.roadType')}
                          </option>
                          {tiposVia.map((via) => (
                            <option value={via.idTipoVia}>
                              {via.nombreTipoVia}
                            </option>
                          ))}
                        </select>
                        <div className="icon icon-small">
                          <IconChat />
                        </div>
                        {errors.tipoVia && errors.tipoVia.type === 'validate' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="tipoVia-error"
                            className="error"
                            htmlFor="tipoVia"
                          >
                            {t('validaciones.empty-value')}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="via-factu" className="control-label">
                        {t('datos.directions.roadName')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.viaFactu ? 'error' : ''
                          }`}
                          id="viaFactu"
                          {...register('viaFactu', {
                            required: true,
                          })}
                          onChange={(e) => handleChange('roadName', e)}
                        />
                        {errors.viaFactu &&
                          errors.viaFactu.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="viaFactu-error"
                              className="error"
                              htmlFor="viaFactu"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-md-1">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="numFactu" className="control-label">
                        {t('datos.directions.number')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.numFactu ? 'error' : ''
                          }`}
                          maxLength={4}
                          id="numFactu"
                          {...register('numFactu', {
                            required: true,
                            pattern: /^[0-9]+$/i,
                          })}
                          onChange={(e) => handleChange('number', e)}
                        />
                        {errors.numFactu &&
                          errors.numFactu.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="numFactu-error"
                              className="error"
                              htmlFor="numFactu"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                        {errors.numFactu && errors.numFactu.type === 'pattern' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="numFactu-error"
                            className="error"
                            htmlFor="numFactu"
                          >
                            {t('validaciones.not-valid-value')}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-md-1">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="portal-factu" className="control-label">
                        {t('datos.directions.portal')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className="form-control"
                          name="portal-factu"
                          maxLength={3}
                          id="portal-factu"
                          onChange={(e) => handleChange('portal', e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-md-1">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="escalera-factu" className="control-label">
                        {t('datos.directions.stairs')}
                      </label>
                      <div className="form-control-block" />
                      <input
                        type="text"
                        className="form-control"
                        name="escalera-factu"
                        maxLength={2}
                        id="escalera-factu"
                        onChange={(e) => handleChange('stairs', e)}
                      />
                    </div>
                  </div>
                  <div className="col-4 col-md-1">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="piso-factu" className="control-label">
                        {t('datos.directions.floor')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className="form-control"
                          name="piso-factu"
                          maxLength={2}
                          id="piso-factu"
                          onChange={(e) => handleChange('floor', e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-md-1">
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="puerta-factu" className="control-label">
                        {t('datos.directions.door')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="text"
                          className="form-control"
                          name="puerta-factu"
                          maxLength={2}
                          id="puerta-factu"
                          onChange={(e) => handleChange('door', e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group select-wrapper u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label className="control-label" htmlFor="country-factu">
                        {t('datos.directions.country')}
                      </label>
                      <div className="form-control-block">
                        <select
                          className="form-control"
                          id="country-fact"
                          onChange={(e) => handleChangeSelect('pais', e)}
                        >
                          {paises.map((p) =>
                            p.codigoAlfa2 !== 'ES' ? (
                              <option value={p.codigoAlfa2}>
                                {p.nombrePais}
                              </option>
                            ) : (
                              <></>
                            ),
                          )}
                        </select>
                        <div className="icon icon-small">
                          <IconChat />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          }
          return false;
        })()}

        <fieldset>
          <div className="row">
            <div className="col-12 col-md-8">
              <div className="u-margin-bottom-medium">
                <p className="control-label u-margin-bottom u-text-bold">
                  {t('tarjetas.hazte-oro.i-gree')}
                </p>

                <div className="checkbox">
                  <label
                    className="checkgroup checkbox__gold"
                    htmlFor="aceptar-legal"
                  >
                    {t('tarjetas.hazte-oro.check-option-one')}
                    <br />
                    {t('tarjetas.hazte-oro.check-option-one-2')}
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.condiciones-oro')}?fromApp=${t('eroski_es')}`}
                      rel="noopener noreferrer"
                      className="link link-oro"
                    >
                      {t('tarjetas.hazte-oro.check-option-one-3')}
                    </a>

                    <input
                      type="checkbox"
                      id="aceptar-legal"
                      onChange={onCheck}
                    />
                    <span id="checkmark-aceptar-legal" className="checkmark" />
                  </label>
                </div>

                <div className="u-margin-bottom-medium">
                  <p className="control-label u-margin-bottom">
                    {t('tarjetas.hazte-oro.i-authorize')}
                  </p>

                  <div className="checkbox">
                    <label
                      className="checkgroup checkbox__gold"
                      htmlFor="titular-cuenta"
                    >
                      {t('tarjetas.hazte-oro.check-option-two')}
                      <br />
                      {t('tarjetas.hazte-oro.check-option-two-2')}
                      <input
                        type="checkbox"
                        onChange={onCheck}
                        id="titular-cuenta"
                      />
                      <span
                        id="checkmark-titular-cuenta"
                        className="checkmark"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div className="u-text-right">
          {(() => {
            if (isDatosIncompletos) {
              return waEventConponentFactory.getComponent(
                WaEventsConstants.ALTA_ORO_COMPLETAR,
              );
            }
            return waEventConponentFactory.getComponent(
              WaEventsConstants.ALTA_ORO,
              null,
              { cuota },
            );
          })()}
          <br />
          <br />
          <span id="error-checks" className="error hide">
            {t('tarjetas.hazte-oro.debes-aceptar')}
          </span>
        </div>
      </form>
    </>
  );
};

export default FacturacionOroForm;
